import React from 'react';
import { CustomLabelMediumSmallBold, CustomLabelSmallMedium, 
    CustomLabelMediumRegularRedHatInto, CustomLabelSmallRegular, 
    CustomLabelSmallMediumRegular } from '../../common/CustomLabel';
import { 
  Grid, 
  Typography, 
//   Button, 
  Card, 
  CardContent,
  Box,
//   Container
} from '@mui/material';
import { styled } from '@mui/material/styles';

// Icons imports (you'll need to import your specific icons)
import MAIL_OUT from "../../../assets/images/mail-out.png";
import FULL_PROJECT_DEVELOPMENT from "../../../assets/gif/FullProjectDevelopement.gif";
// import SETTING_BULB from "../../../assets/services/setting-bulb.png";
// import CODE_TOOL from "../../../assets/services/code-tool.png";
// import GRAPH_VIEW from "../../../assets/services/graph-view.png";
import MVP from "../../../assets/services/MPV or launching a new product.png";
import REVAMP from "../../../assets/services/Businesses revamping.png";
import CUSTOM from "../../../assets/services/creating custom software.png";
// import { mt } from 'date-fns/locale';

const StyledCard = styled(Card)(({ theme }) => ({
  background: 'white',
  borderRadius: theme.spacing(2),
  height: '100%',
  transition: 'transform 0.2s',
  '&:hover': {
    transform: 'translateY(-4px)',
    '& .MuiCardContent-root': {
            '& .benefit-icon': {
                filter: 'grayscale(0%)',
            },
        },
    '& .benefit-title': {
        filter: 'grayscale(100%)',
        transition: 'filter 0.3s ease',
    },
  }
}));

const BenefitIcon = styled(Box)(({ theme }) => ({
  color: '#5E17EB',
  marginBottom: theme.spacing(2),
  '& svg': {
    fontSize: '2rem',
  },
  filter: 'grayscale(100%)',
  transition: 'filter 0.3s ease',
}));

const ServicesOnDemandDevelopers = ({setShowFullProject}) => {

    const Comm = () => {
        return (
            <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.9336 20L18.9336 25L27.2669 16.6667" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M20.6003 36.6663C29.805 36.6663 37.2669 29.2044 37.2669 19.9997C37.2669 10.7949 29.805 3.33301 20.6003 3.33301C11.3955 3.33301 3.93359 10.7949 3.93359 19.9997C3.93359 23.0354 4.74521 25.8816 6.1633 28.333L4.76693 35.833L12.2669 34.4366C14.7184 35.8547 17.5645 36.6663 20.6003 36.6663Z" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            
        )
    }

    const BrainCode = () => {
        return (
            <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.562 36.667L11.5621 31.9053C11.3023 29.3204 9.58647 27.3612 8.00196 25.0003M24.2893 36.667L24.2893 33.81C32.471 33.81 31.562 24.2865 31.562 24.2865C31.562 24.2865 35.1983 24.2865 35.1983 20.4771L31.5621 14.763C31.5621 7.14419 25.3807 3.40314 18.8348 3.3348C15.1674 3.29651 12.2397 4.21906 10.0518 5.83366" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M21.8659 11.6667L25.1992 15.8333L21.8659 20" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8.53255 11.6667L5.19922 15.8333L8.53255 20" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16.8665 10L13.5332 21.6667" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


        )
    }

    const GroupIcon = () => {
        return (
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.666 30V28.3333C11.666 23.731 15.397 20 19.9993 20V20C24.6017 20 28.3327 23.731 28.3327 28.3333V30" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M1.66602 29.9997V28.333C1.66602 25.5716 3.90459 23.333 6.66602 23.333V23.333" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M38.334 29.9997V28.333C38.334 25.5716 36.0954 23.333 33.334 23.333V23.333" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M20 20C22.7614 20 25 17.7614 25 15C25 12.2386 22.7614 10 20 10C17.2386 10 15 12.2386 15 15C15 17.7614 17.2386 20 20 20Z" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M6.66732 23.3337C8.50827 23.3337 10.0007 21.8413 10.0007 20.0003C10.0007 18.1594 8.50827 16.667 6.66732 16.667C4.82637 16.667 3.33398 18.1594 3.33398 20.0003C3.33398 21.8413 4.82637 23.3337 6.66732 23.3337Z" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M33.3333 23.3337C35.1743 23.3337 36.6667 21.8413 36.6667 20.0003C36.6667 18.1594 35.1743 16.667 33.3333 16.667C31.4924 16.667 30 18.1594 30 20.0003C30 21.8413 31.4924 23.3337 33.3333 23.3337Z" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            
            
        )
    }

    const Graph = () => {
        return (
            <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M34.1335 33.333H7.4668V6.66634" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7.4668 27.5L20.8001 15L25.8001 20L33.3001 12.5" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

            
        )
    }

    const Tool = () => {
        return (
            <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.1523 17.6777L5.36723 29.4628C4.06548 30.7646 4.06548 32.8751 5.36723 34.1769V34.1769C6.66898 35.4786 8.77953 35.4786 10.0813 34.1769L21.8664 22.3918" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M29.0535 22.9979L35.5174 29.4617C36.8191 30.7634 36.8191 32.874 35.5174 34.1757V34.1757C34.2156 35.4775 32.1051 35.4775 30.8033 34.1757L20.4559 23.8283" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M11.6204 9.84L8.08491 11.0185L4.54938 5.12595L6.9064 2.76893L12.799 6.30446L11.6204 9.84ZM11.6204 9.84L16.3375 14.557" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M17.1532 17.6781C15.7468 14.0897 16.0218 9.38145 18.921 6.48225C21.8202 3.58306 27.1706 2.94672 30.1168 4.71449L25.049 9.78228L24.578 14.9673L29.7631 14.4963L34.8309 9.42853C36.5986 12.3748 35.9623 17.7252 33.0631 20.6244C30.1639 23.5236 25.4556 23.7985 21.8673 22.3922" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            
        )
    }

    
  const benefits = [
    {
      icon: <GroupIcon />,
      title: 'From Design to Code',
      description: 'We start by creating a custom brand kit with logos, colors, and typography that match your vision. This flows directly into UI/UX design, keeping everything visually consistent from start to finish.'
    },
    {
      icon: <Comm />,
      title: 'Future-Focused Development',
      description: 'We develop websites, apps, and AI tools that fit your business goals. Using scalable frameworks and the latest technologies, we ensure your product stays reliable as your business grows.'
    },
    {
      icon: <BrainCode />,
      title: 'AI-Integration',
      description: 'We don’t just add AI - we build custom AI and machine learning models that fit your workflow. Whether it’s chatbots, analytics, or automation, we make AI practical and useful.'
    },
    {
      icon: <Graph />,
      title: 'Thorough Testing Before Launch',
      description: 'Before going live, our QA team runs detailed tests to simulate real-world use. We identify and fix issues, optimize performance, and ensure compliance with industry standards.'
    },
    {
      icon: <Tool />,
      title: 'Deployment & Maintenance',
      description: 'We manage everything from server setup and app-store submissions to go-live logistics. After launch, our 3-month maintenance plan covers Bug fixes, security patches, and priority support to keep your product running smoothly.'
    },
  ];

  const whatThis = [
    {
      icon: <img src={MVP} alt="MVP" style={{ width: '100px', height: '100px' }} />,
      title : 'For Startups',
      description: 'Startups building an MVP or launching a new product.'
    },
    {
      icon: <img src={CUSTOM} alt="Custom" style={{ width: '100px', height: '100px' }} />,
      title : 'For Companies',
      description: 'Companies creating custom software Customized to their operations.'
    },
    {
      icon: <img src={REVAMP} alt="Revamp" style={{ width: '100px', height: '100px' }} />,
      title : 'For Businesses',
      description: 'Businesses revamping or expanding their digital presence.'
    }
  ];

  return (
      <Grid container sx={{marginTop: {xs: "40px"}, background : "#F5F5F5", px :{ xs: 1, md: 5}}}>

        <Grid item xs={10.5} md={4.5} sx={{padding: {xs: "20px", md: "20px 2px"},
                                    marginTop: {xs: "60px"},
                                    marginLeft: {xs: "20px"},
                                    display: "flex", 
                                    justifyContent: "center", 
                                    alignItems: "center",
                                    border: "1px solid #F5F5F5",
                                    borderRadius: 10,
                                    background: "white",
                                    }}>
            <img src={FULL_PROJECT_DEVELOPMENT} style={{width: "100%", height: "100%"}} alt="Full Project Development" />
        </Grid>
        <Grid item xs={12} md={7} sx={{padding: {xs: "20px", md: "100px 80px"}}}>
            <CustomLabelMediumSmallBold
                textAlign={ {xs:"center", md:"left"}}
                text={"Full Project Development"}
                color={"#5E17EB"}
            />
           <Typography  sx={{ my: 2 , fontSize: {xs: "16px", md: "20px"}, fontWeight: "500" ,  fontFamily: 'Red Hat Display',}}>
           From shaping your brand identity to delivering a fully functional app, website, or AI solution, we take care of every step. 
           Our <b>Full Project Development </b> service gives you a complete, managed solution designed around your needs, so you can focus on growing your business.
          </Typography>
          <CustomLabelMediumRegularRedHatInto textAlign={"left"} normal={"1.5"} fontWeight={'400'} style={{ my: 4, mt: 8}}>
          With our <b>IT Project Development Services,</b> we manage everything from planning and design to development, testing, and final launch. 
          We also provide three months of post-launch support to keep things running smoothly.

          Whether you’re starting something new or improving an existing platform, our Project Management and Development team handles all the technical work. 
          We make sure your project is completed on time, runs without issues, and meets your goals.
          </CustomLabelMediumRegularRedHatInto>
          <Grid item container sx={{
                    width: {xs: "100%", md: "35%"},
                    border: "1.5px solid #F5F5F5",
                    borderRadius: "20px",
                    padding: {xs: "10px 15px", md: "15px 25px"},
                    background: "#5E17EB", 
                    marginTop: "20px", 
                    cursor: "pointer",
                    transition: 'transform 0.2s ease',
                    alignItems: "center",
                    justifyContent: "center"
                    
                }}
                onClick={(e) => {
                  e.stopPropagation(); // Prevents triggering parent hover effect
                  setShowFullProject(true);
              }}
              >
                    <Grid item>
                <img src={MAIL_OUT} alt={"MAIL OUT"} />
                    </Grid>
                    <Grid item style={{marginLeft: "10px"}}>
                <CustomLabelSmallMedium text={"Get in Touch Now!"} color="white"/>
            </Grid>
        </Grid>
          
        </Grid>


        <Grid item xs={12} md={12} sx={{padding: {xs: "20px", md: "40px 40px"}}}>
            <Box sx={{ mt: 8 }}>
                <Grid item sx={{marginBottom: "20px", display : "flex" , justifyContent:"center"}}> 
                    <CustomLabelMediumSmallBold 
                    textAlign={ {xs:"center", md:"left"}}
                    text={"Why do Businesses Choose OSTRYX for Full Project Development?"} color="#5E17EB" />
                </Grid>
                <Grid container spacing={3}>
                {benefits.map((benefit, index) => (
                    <Grid item xs={12} sm={6} md={2.4} key={index}>
                    <StyledCard elevation={0}>
                        <CardContent>
                        <BenefitIcon>
                            {benefit.icon}
                        </BenefitIcon>
                        <Grid sx={{ marginBottom: "16px" }}>
                            <CustomLabelSmallMediumRegular
                                color="#5E17EB"
                                fontWeight="700"
                                normal="left"
                                text={benefit.title}
                            />
                            </Grid>
                            <CustomLabelSmallRegular
                                fontWeight="400"
                                normal="left"
                                color="#333333"
                                text={benefit.description}
                            />
                        </CardContent>
                    </StyledCard>
                    </Grid>
                ))}
                </Grid>
            </Box>
        </Grid>
        

        <Grid container sx={{padding: {xs: "20px", md: "20px 40px"}}}>
            <Box>
                <Grid item sx={{marginBottom: "20px"}}> 
                    <CustomLabelMediumSmallBold  text={"Who this is for ?"} color="#5E17EB" />
                </Grid>
                <Grid container spacing={3}>
                {whatThis.map((whatThis, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                    <StyledCard elevation={0}>
                    <CardContent sx={{ display: 'flex', alignItems: 'center' }}>
                        <BenefitIcon className="benefit-icon" sx={{ marginRight: 2 }}>
                            {whatThis.icon}
                        </BenefitIcon>
                        <Box gap={2} sx={{ display: 'flex', flexDirection: 'column' }}>
                            <CustomLabelSmallRegular 
                                className="benefit-title"
                                textAlign="left" 
                                text={whatThis.title} 
                                fontWeight="700"
                                sx={{ filter: 'grayscale(100%)', transition: 'filter 0.3s ease' }}
                            />
                            <CustomLabelSmallRegular 
                                textAlign={"left"} 
                                text={whatThis.description} 
                                fontWeight={"400"}
                            />
                        </Box>
                    </CardContent>
                    </StyledCard>
                    </Grid>
                ))}
                </Grid>
            </Box>
        </Grid>

      </Grid>
  );
};

export default ServicesOnDemandDevelopers;